import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import logoEkose from '../../images/logoekose.svg';

const AuthLayout: React.FC = () => {
  const { isAuthenticated, user } = useAuth();

  // Redirect if already authenticated
  if (isAuthenticated && user) {
    const role = user.role?.toUpperCase();
    if (role === 'PATIENT') return <Navigate to="/patient" replace />;
    if (role === 'DOCTOR') return <Navigate to="/doctor" replace />;
    if (role === 'ADMIN') return <Navigate to="/admin" replace />;
    
    // Si le rôle n'est pas reconnu, forcer la déconnexion ou rediriger vers une page d'erreur
    return <Navigate to="/unauthorized" replace />;
  }

  return (
    <div className="w-full min-h-screen bg-slate-950">
      <Outlet />
    </div>
  );
};

export default AuthLayout;